import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_36: FaireProductEntity = {
  token: "starter_collection_36",
  type: "product",
  name: "Tulip Wine Glass (Set of 4)",
  brandName: "Sophie Lou Jacobsen",
  imageUrl: "",
  priceDollars: 108,
  msrpDollars: 216,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
